import styled from "styled-components";

const calcRight = (active) => {
  // console.log(typeof active);
  const right = active * 49;

  return `${right}%`;
};

export const ToggleTabsStyled = styled.div`
  width: ${({ small }) => (!small ? "270px" : "100%")};
  border-radius: 14px;
  height: ${({ small }) => (!small ? "42px" : "32px")};
  background-color: #e1e2e7;

  font-size: ${({ small }) => small && ".9em"};

  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  & > button {
    flex-grow: 1;
    flex-basis: 49%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1;
  }

  &::after {
    content: "";
    height: 85%;
    width: 50%;
    position: absolute;
    display: block;
    background-color: ${({ small }) => (!small ? "white" : "#FFBF1D")};
    border-radius: 12px;
    box-shadow: 0 3px 8px 0 rgba(42, 46, 67, 0.2);
    border: solid 0.5px rgba(53, 58, 80, 0.05);
    transition: 1s right;
    right: ${(props) => calcRight(props.active)};
  }
`;
